import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { get, includes } from 'lodash';
import i18n from 'i18n';
import scaleSize from 'utils/scale-size';
import PosterPlayIcon from 'components/Icons/item-play';
import { StyledAvailableStatus, Cover, CoverWrapper, Header, StyledImageOverlay } from './StyledComponents';
import DetailsMetadata from './Metadata';

const coverOffsets = [0, 445];
const metadatOffset = [270, 590];

const coverConfig = {
  leaveFor: {
    right: '',
    up: '@WATCH_CONTROLS',
    left: '@EXPAND_DESCRIPTION_BUTTON',
    down: '@EXTRA_CONTENT_SECTION',
  },
};

const COVER_ID = 'details-cover-element';

const DetailsHeader = (props) => {
  const { data, selectedSection, IsSectionCompletelyScrolled, noAnimation } = props;
  const { onCoverFocus, onCoverEnter } = props;
  const { posterUrl } = data;
  const isAvailableToWatch = !includes(['MISSING_SUBSCRIPTION', 'NOT_AUTHENTICATED'], data.visibilityDetails);
  const backgroundImage = get(data.imageUrls, ['background']);

  const onEnter = useCallback(({ id }) => onCoverEnter({ id, type: 'cover' }), [onCoverEnter]);

  let availableStatus = null;

  if (isAvailableToWatch && data.visibilityVodType === 'TVOD') {
    availableStatus = i18n.t('detailsVOD.availableUntil', {
      endDate: moment(data.endDate).format('DD.MM.YY, HH:MM'),
    });
  } else if (isAvailableToWatch) {
    availableStatus = i18n.t('detailsVOD.available').toUpperCase();
  }

  return (
    <>
      <CoverWrapper
        sectionName={'COVER'}
        config={coverConfig}
        noAnimation={noAnimation}
        coverOffset={IsSectionCompletelyScrolled ? 0 : coverOffsets[selectedSection]}
        opacity={IsSectionCompletelyScrolled ? 0.5 : 1}
      >
        <Cover cover={posterUrl} onFocus={onCoverFocus} onEnter={onEnter} id={COVER_ID} payload={{ id: COVER_ID }}>
          <PosterPlayIcon />
        </Cover>
        {availableStatus && <StyledAvailableStatus>{availableStatus}</StyledAvailableStatus>}
      </CoverWrapper>
      <Header imageUrl={backgroundImage}>
        {backgroundImage && <StyledImageOverlay />}
        <DetailsMetadata
          data={data}
          offset={scaleSize(selectedSection >= 1 || IsSectionCompletelyScrolled ? metadatOffset[1] : metadatOffset[0])}
          small={selectedSection >= 1}
          isVisible={!IsSectionCompletelyScrolled}
        />
      </Header>
    </>
  );
};

DetailsHeader.propTypes = {
  data: PropTypes.object.isRequired,
  selectedSection: PropTypes.number.isRequired,
  onCoverFocus: PropTypes.func.isRequired,
  onCoverEnter: PropTypes.func.isRequired,
  noAnimation: PropTypes.bool,
  IsSectionCompletelyScrolled: PropTypes.bool,
};

export default memo(DetailsHeader);
